export default "__VITE_ASSET__CCybS$Md__"